import React, {useState, useEffect} from 'react';

import withErrorHandler from '../../../hocs/withErrorHandler'
import { useTheme } from '@emotion/react';
import axios from '../../../httpClients/axios-datamerch'

import MemberSelect from '../../Account/MembersSelect'
import useClasses from '../../../helpers/useClasses';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';


import {
  Grid,
  TextField,
  CircularProgress,
  Backdrop
} from '@mui/material';

const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  },
  selectContainer2: {
    padding: '0px 8px 4px 8px',
    backgroundColor: theme.palette.primary.light,
    borderRadius: '5px'
  },
  input: {
    background: theme.palette.light_blue
  }
});

const NoteInfo = props => {
  const classes = useClasses(styles);
  const { 
    onChange,
    category,
    quick_note,
    proxied_creator,
    note,
    is_dm_admin,
    accounts,
    loading,
    merchant_add,
    mode,
    submission_source,
    broker_name,
    plan_level,
    show_broker_name,
    open_funding_date,
    open_funding_status,
    open_funding_amount
  } = props;

  let categories = [
    {
      value: '',
      label: ''
    },
    {
      value: 'Default Account',
      label: 'Default Account'
    },
    {
      value: 'Suspicious Activity',
      label: 'Suspicious Activity'
    },
    {
      value: 'Slow Pay',
      label: 'Slow Pay'
    },
    // {
    //   value: 'Split Payer',
    //   label: 'Split Payer'
    // },
    {
      value: 'Stacking History',
      label: 'Stacking History'
    },
    // {
    //   value: 'Criminal History',
    //   label: 'Criminal History'
    // },
    // {
    //   value: 'Covid-19 Hardship',
    //   label: 'Covid-19 Hardship'
    // },
    {
      value: 'Open Funding',
      label: 'Open Funding'
    },
    {
      value: 'Other',
      label: 'Other'
    },
    {
      value: 'Default Satisfied',
      label: 'Default Satisfied'
    }
  ];

  if (is_dm_admin) {
    categories = [
      {
        value: '',
        label: ''
      },
      {
        value: 'Default Account',
        label: 'Default Account'
      },
      {
        value: 'Suspicious Activity',
        label: 'Suspicious Activity'
      },
      {
        value: 'Slow Pay',
        label: 'Slow Pay'
      },
      // {
      //   value: 'Split Payer',
      //   label: 'Split Payer'
      // },
      {
        value: 'Stacking History',
        label: 'Stacking History'
      },
      // {
      //   value: 'Criminal History',
      //   label: 'Criminal History'
      // },
      // {
      //   value: 'Covid-19 Hardship',
      //   label: 'Covid-19 Hardship'
      // },
      {
        value: 'Open Funding',
        label: 'Open Funding'
      },
       {
        value: 'Other',
        label: 'Other'
      },
      {
        value: 'Default Satisfied',
        label: 'Default Satisfied'
      },
      {
        value: 'Merchant Dispute',
        label: 'Merchant Dispute'
      }
    ];
  }

  let quick_notes = [];
  
  if (category === 'Default Satisfied') {
    quick_notes = [
      {
        value: '',
        label: ''
      },
      {
        value: 'Paid in Full',
        label: 'Paid in Full'
      },
      {
        value: 'Settled for less than originally owed',
        label: 'Settled for less than originally owed'
      },
      {
        value: 'Other',
        label: 'Other'
      }
    ];
  }

  let open_funding_statuses = [];
  
  if (category === 'Open Funding') {
    open_funding_statuses = [
      {
        value: '',
        label: ''
      },
      {
        value: 'Active',
        label: 'Active'
      },
      {
        value: 'Reduced Payments',
        label: 'Reduced Payments'
      },
      {
        value: 'Paid in Full',
        label: 'Paid in Full'
      },
      {
        value: 'Renewed',
        label: 'Renewed'
      }
    ];
  }

  const submission_sources = [
    {
      value: '',
      label: ''
    },
    {
      value: 'in-house',
      label: 'In-house/Retail'
    },
    {
      value: 'broker',
      label: 'Broker/ISO'
    }
  ];

  let membersSelect = null
  
  if (is_dm_admin && !merchant_add && mode==='add'){
    membersSelect = (
      <Grid
          item
          md={12}
          xs={12}
        >
        <Backdrop className={classes.backdrop} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Grid>
    )
    if(!loading){
      membersSelect = (
        <Grid
          container
          spacing={0}
        >
          <Grid
            size={{xs:12, md:12}}
          >
            <MemberSelect
              accounts={accounts || []}
              proxied_creator={proxied_creator}
              label="Add on Behalf of"
              onChange={onChange}
            />
          </Grid>
        </Grid>
      )
    }
  }
  
  return (
    <React.Fragment>
      <Grid
        container
        spacing={0}
      >
        {membersSelect}
        <Grid
            size={{xs:12, md:12}}
          >
            { mode === 'add' || is_dm_admin ?
              <TextField
              fullWidth
              label="Category"
              margin="dense"
              name="category"
              onChange={(event) => onChange(event, 'category')}
              required
              select
              SelectProps={{ native: true }}
              value={category || ''}
              variant="outlined"
            >
              {categories.map(option => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </TextField>
            : ( category !== 'Default Satisfied' && category !== 'Split Payer' && category !== 'Covid-19 Hardship') ?
              <TextField
                fullWidth
                label="Category"
                margin="dense"
                name="category"
                onChange={(event) => onChange(event, 'category')}
                required
                select
                SelectProps={{ native: true }}
                value={category || ''}
                variant="outlined"
              >
                {categories.map(option => (
                  option.value !== 'Default Satisfied' ?
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                  : null
                ))}
              </TextField>
            :
            <TextField
              fullWidth
              label="Category"
              margin="dense"
              name="category"
              onChange={(event) => onChange(event, 'category')}
              required
              disabled
              value={category || ''}
              variant="outlined"
            >
              {category}
            </TextField>
            }
          </Grid>
          {category === 'Default Satisfied' ?
            <Grid
              size={{xs:12, md:12}}
            >
              <TextField
                fullWidth
                label="Quick Note Options"
                margin="dense"
                name="quick_note"
                onChange={(event) => onChange(event, 'note')}
                select
                SelectProps={{ native: true }}
                value={quick_note || ''}
                variant="outlined"
              >
                {quick_notes.map(option => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Grid>
            : null
          }
          {category === 'Open Funding' ?
            <Grid
              size={{xs:12, md:12}}
            >
              <Grid
                container
                spacing={3}
              >
                <Grid
                  size={{xs:12, md:4}}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      label="Date"
                      margin="dense"
                      name="open_funding_date"
                      onChange={(newValue) => onChange(newValue, 'open_funding_date')}
                      required
                      value={dayjs(open_funding_date)}
                      variant="outlined"
                      format="MM/DD/YYYY"
                      sx={{
                        marginTop: '8px',
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid
                  size={{xs:12, md:4}}
                >
                  <TextField
                    fullWidth
                    label="Amount"
                    margin="dense"
                    name="open_funding_amount"
                    onChange={(event) => onChange(event, 'open_funding_amount')}
                    required
                    value={open_funding_amount || ''}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  size={{xs:12, md:4}}
                >
                  <TextField
                    fullWidth
                    label="Status"
                    margin="dense"
                    name="open_funding_status"
                    onChange={(event) => onChange(event, 'open_funding_status')}
                    required
                    select
                    SelectProps={{ native: true }}
                    value={open_funding_status || ''}
                    variant="outlined"
                  >
                    {open_funding_statuses.map(option => (
                      <option
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            : null
          }
          <Grid
            size={{xs:12, md:12}}
          >
            <TextField
              fullWidth
              label="Note"
              margin="dense"
              name="note"
              onChange={(event) => onChange(event, 'note')}
              required
              value={note || ''}
              variant="outlined"
              multiline
              minRows="2"
            />
          </Grid>
      </Grid>
      { plan_level==='PRO' || plan_level==='BASIC' ?
          <Grid
          container
          spacing={3}
        >
          <Grid
              size={{xs:12, md:4}}
            >
              <TextField
                fullWidth
                label="Submission Source"
                margin="dense"
                name="submission_source"
                onChange={(event) => {onChange(event, 'submission_source')}}
                select
                SelectProps={{ native: true }}
                value={submission_source || ''}
                variant="outlined"
                InputProps={{ className: classes.input }}
              >
                {submission_sources.map(option => (
                  <option
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              size={{xs:12, md:8}}
            >
              { show_broker_name ?
              <TextField
                fullWidth
                label="Broker Name"
                margin="dense"
                name="broker_name"
                onChange={(event) => onChange(event, 'broker_name')}
                value={broker_name || ''}
                variant="outlined"
                InputProps={{ className: classes.input }}
                helperText="name only, do not add comments"
                required={show_broker_name}
              />
              : null}
            </Grid>
        </Grid>
        : null
      }
    </React.Fragment>
  );
};

export default withErrorHandler(NoteInfo, axios)